import { PlusIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import { Link } from 'react-router';
import { useAppointmentProposalOptions } from '../../data-access/appointmentProposalOptions';
import { useProposalTemplates } from '../../data-access/proposalTemplate';
import ROUTE_PATHS from '../../routes/paths';

interface ApplyProposalTemplateOptionsButtonProps {
  disabled?: boolean;
}

const ApplyProposalTemplateOptionsButton: React.FC<
  ApplyProposalTemplateOptionsButtonProps
> = ({ disabled }) => {
  const { proposalTemplateOptions } = useProposalTemplates();
  const { currentOption } = useAppointmentProposalOptions();

  return !proposalTemplateOptions.length || !currentOption ? null : (
    <Button
      component={Link}
      to={ROUTE_PATHS.APPOINTMENT_PATH({
        appointmentId: currentOption.appointmentId,
        appointmentProposalId: currentOption.appointmentProposalId,
        path: 'options',
        extraPath: 'manage/templates/options',
      })}
      color="softGold"
      startIcon={<PlusIcon />}
      disabled={disabled}
    >
      Apply option templates
    </Button>
  );
};

export default ApplyProposalTemplateOptionsButton;
